// extracted by mini-css-extract-plugin
export default {"formRow":"UsersCRUD_formRow__xk6Dd","formField":"UsersCRUD_formField__CFCzn"};